<template>
  <div title="工作日历">
    <div>
      <a-calendar v-model="calendarValue" mode="month" class="work-calendar-content" @panelChange="handlePanelChange" @select="handleSelecrt">
        <div slot="headerRender">
          <div style="margin-top: 11px; margin-bottom: 12px; display: flex; align-items: center">
            <a-button-group>
              <a-button @click="prevMonth()"><a-icon type="left" /></a-button>
              <a-button @click="showTotay()">今天</a-button>
              <a-button @click="nextMonth()"><a-icon type="right" /></a-button>
            </a-button-group>
            <a-month-picker v-model="calendarValue" class="month-picker-customer" format="YYYY年MM月" :allow-clear="false" placeholder="请选择月" @change="changeFilterMoth">
              <a-icon slot="suffixIcon" type="down" />
            </a-month-picker>
          </div>
        </div>
        <div slot="dateFullCellRender" slot-scope="value" class="ant-fullcalendar-date" :class="{ 'ant-fullcalendar-date-has-content': getListData(value).length > 0 }">
          <div class="ant-fullcalendar-value ant-fullcalendar-value-customer">
            <span class="text">
              {{ getCaledarDate(value) }}
            </span>
          </div>
          <div class="ant-fullcalendar-content">
            <ul class="events">
              <li v-for="(item, idx) in getListData(value)" :key="idx">
                <a-badge status="success" :class="item.type + ' ' + item.workType" />
                <span style="margin-left: 3px; font-size: 13px">
                  {{ item.issueName }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </a-calendar>
    </div>
    <WorkCalendarDetail ref="workCalendarDetailRef" :calendar-data="calendarData" @saveOk="getUserWorkInfoData()" />
  </div>
</template>

<script>
import moment from 'moment';
import WorkCalendarDetail from './WorkCalendarDetail.vue';
import { userList } from '@/api/system/auth';
import { getUserWorkInfo } from '@/api/datacenter/datacenter';
import { teamList } from '@/api/system/team';

export default {
  components: { WorkCalendarDetail },
  props: {
    userList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      calendarData: {
        current_date: '2025-02-01',
        items: [
          {
            date: '2025-02-01',
            items: [
              {
                type: 'task',
                workType: 'dev',
                issueId: 34905,
                projectId: 147,
                issueName: '管理后台增加消息推送配置页面',
                point: 3,
                status: 1
              }
            ]
          }
        ]
      },
      calendarValue: moment(new Date()),
      selectDateValue: '',
      userData: [],
      filterForm: {
        about: 1,
        userList: [],
        teamList: []
      },
      month: null
    };
  },
  computed: {
    isOnly() {
      if (this.filterForm.about === 1) {
        return this.filterForm.userList.length === 1;
      }
      return false;
    }
  },
  watch: {
    filterForm: {
      handler(val, old) {
        this.getUserWorkInfoData();
      },
      deep: true
    }
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    changeFilterMoth(date) {
      this.calendarValue = date;
      this.getUserWorkInfoData();
    },
    // 获取用户列表
    async getUserList() {
      await userList({}).then(async res => {
        this.userData = res.data.users;
      });
    },
    // 点击某天
    handleSelecrt(value) {
      // const selectDate = value.format('YYYY-MM-DD HH:mm:ss'); // 当前选中的日历时间
      const selectDate = value.format('YYYY-MM-DD');
      this.selectDateValue = selectDate;
      const _list = this.getListData(value);
      this.$refs.workCalendarDetailRef.open(value, _list);
    },
    // 获取日历的日期
    getCaledarDate(value) {
      let str = value.format('YYYY-MM-DD').substring(8, 10);
      if (str[0] === '0') {
        str = str.substring(1, 2);
      }
      return str;
    },
    getListData(value) {
      const listData = [];
      const yearMonthDay = value.format('YYYY-MM-DD');
      const _datas = this.calendarData.items || [];
      const valueData = _datas.find(item => item.date === yearMonthDay);
      if (valueData) {
        return valueData.items || [];
      }
      return listData || [];
    },
    /* 上个月 */
    prevMonth() {
      const newMonth = moment(this.calendarValue).subtract(1, 'months');
      this.calendarValue = newMonth;
      this.getUserWorkInfoData();
    },
    /* 下个月 */
    nextMonth() {
      const newMonth = moment(this.calendarValue).add(1, 'months');
      this.calendarValue = newMonth;
      this.getUserWorkInfoData();
    },
    // 返回今天
    showTotay() {
      const today = moment(new Date());
      this.calendarValue = today;
      this.getUserWorkInfoData();
    },
    yearOptions(year) {
      const options = [];
      for (let i = year - 10; i < year + 10; i += 1) {
        options.push({ value: i, lable: i + '年' });
      }
      return options;
    },
    handlePanelChange(value, mode) {
      if (mode === 'month') {
        this.calendarValue = value;
        // this.month = value.month() + 1;
        this.getUserWorkInfoData();
      }
    },
    getUserWorkInfoData() {
      if (this.filterForm.about === 1) {
        if (!this.filterForm.userList || this.filterForm.userList.length === 0) {
          this.filterForm.userList = [this.$store.state.userInfo.id];
        }
      }

      const filterForm = JSON.parse(JSON.stringify(this.filterForm));

      // 获取当前月的 1 号 0 点 0 分 0 秒
      const startOfCurrentMonth = moment(this.calendarValue).startOf('month');
      // / 获取下个月 1 号 0 点 0 分 0 秒
      const startOfNextMonth = moment(this.calendarValue).add(1, 'month').startOf('month');

      const start = startOfCurrentMonth.format('YYYY-MM-DD HH:mm:ss');
      const end = startOfNextMonth.format('YYYY-MM-DD HH:mm:ss');
      filterForm['beginTime'] = start;
      filterForm['endTime'] = end;

      if (filterForm.about === 1) {
        filterForm.teamList = [];
      } else if (filterForm.about === 2) {
        filterForm.userList = [];
      }

      getUserWorkInfo(filterForm)
        .then(res => {
          // this.calendarData = res.data || {};
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .work-calendar-content {
  table,
  table tr th,
  table tr td {
    border: 1px solid #f0eded;
  }

  .ant-fullcalendar-header {
    padding-right: 0;
    text-align: left;
    .ant-radio-group {
      // 去掉切换模式按钮
      display: none !important;
    }
  }
  .ant-fullcalendar {
    //   // border: 1px solid #e4dfdf;
    //   border-radius: 5px;

    .ant-fullcalendar-calendar-body {
      padding: 0px 0px 0px;
    }
  }
}

/deep/.ant-fullcalendar-table {
  > thead {
    height: 32px;
    .ant-fullcalendar-column-header {
      padding-bottom: 0;
    }
  }
  // 表格
  .ant-fullcalendar-tbody {
    .ant-fullcalendar-cell {
      border-collapse: collapse;
      padding: 0;
    }
    .ant-fullcalendar-date {
      height: 130px;
      border: 0;
      margin: 0;
      .ant-fullcalendar-content {
        height: 100px;
      }
    }
  }
}

/*日历单元格，存在内容时，背景为灰色*/
// /deep/ .ant-fullcalendar-date-has-content {
//   background-color: #f3f3f3;
// }
/*日历单元格-今天 背景*/
// /deep/ .ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date::after {
//   content: '今天';
//   font-size: 30px;
//   position: absolute;
//   width: 100%;
//   text-align: right;
//   right: 6px;
//   bottom: 0;
//   color: rgba(145, 211, 255, 0.65);
//   letter-spacing: 5px;
//   font-weight: bold;
// }

/deep/ .ant-fullcalendar-column-header-inner {
  // 头部星期几样式
  text-align: left;
  padding-left: 7px;
  color: #2c2f35;
}

/deep/.ant-fullcalendar-cell:not(.ant-fullcalendar-next-month-btn-day):not(.ant-fullcalendar-last-month-cell) {
  //排除前后置灰的字体颜色
  .ant-fullcalendar-value {
    color: #2c2f35 !important;
  }
}

/deep/ .ant-fullcalendar-fullscreen .ant-fullcalendar-value {
  //日期单元格header样式
  text-align: left !important;
  font-weight: 600;
  font-size: 16px;
}

/deep/ .ant-fullcalendar-today .ant-fullcalendar-value-customer {
  .text {
    display: inline-block;
    height: 24px;
    line-height: 24px;
    text-align: center;
    width: 24px;
    background: #2955e7;
    color: #fff;
    border-radius: 50%;
  }
}

.ant-fullcalendar-content {
  overflow: hidden;
  .not-only {
    height: 100%;
    text-align: center;
    font-weight: 700;
    font-size: 60px;
    background: -webkit-linear-gradient(#90b9f1, #448ef7, #44f77d);
    -webkit-text-fill-color: transparent;
    // display: inline-block;
  }
}

.ant-fullcalendar-content:hover {
  overflow: auto;
}

/deep/.events {
  padding-left: 0px;
  li {
    // background: #64f2a2;
    border-radius: 5px;
    padding-left: 0px;
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .ant-tag {
      width: 100%;
      margin: 0;
    }
    .ant-badge-status-text {
      // font-size: 13px;
      margin: 0;
    }
  }
}

/deep/.month-picker-customer {
  width: 140px;
  margin-left: 12px;
  cursor: pointer;
  .ant-calendar-picker-input {
    padding: 0px 5px 0;
    border: 0;
    font-size: 18px;
    color: #2c2f35;
    // height: auto;
  }
  .ant-calendar-picker-input:focus {
    border: 0;
  }

  .ant-calendar-picker-icon {
    color: #2c2f35;
  }
}

/deep/.month-picker-customer:hover {
  .ant-calendar-picker-input {
    background: #f0eded;
  }
}

//去掉点击后的日历单元框背景颜色
.ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month,
.ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date {
  background: none;
}

//强制覆盖hover样式
/deep/.ant-fullcalendar-date:hover {
  background: #e6f7ff !important;
}
</style>
